import ConfirmModal from "kustom-front/src/components/molecules/ConfirmModal";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import "./style.scss";

interface Props {
  display: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

const DraftDeleteModal: FunctionComponent<Props> = ({ display, onConfirm, onDismiss }) => {
  const intl = useIntl();

  return (
    <ConfirmModal
      display={display}
      confirmLabel={intl.formatMessage({ id: "cheerz_Drafts_delete_button" })}
      dismissLabel={intl.formatMessage({ id: "cheerz_Drafts_cancel_button" })}
      onDismiss={onDismiss}
      onConfirm={onConfirm}
    >
      <div className="DraftDeleteModal">
        <h2 className="DraftDeleteModal-title">
          {intl.formatMessage({ id: "cheerz_Drafts_delete_modal_title" })}
        </h2>
        <p className="DraftDeleteModal-message">
          {intl.formatMessage({ id: "cheerz_Drafts_delete_modal_message" })}
        </p>
      </div>
    </ConfirmModal>
  );
};

export default DraftDeleteModal;
